module.exports = __webpack_public_path__ + "img/fushi.4f6cd62b.png";